module.exports = __webpack_public_path__ + "img/이스포츠.5da4cc06.jpg";